"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionDetailsModal = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const circleCloseIcon_svg_1 = __importDefault(require("../../../../assets/icons/circleCloseIcon.svg"));
const colors_1 = require("../../../../assets/styles/colors");
const useScreenSizeDetection_1 = __importDefault(require("../../../../utils/useScreenSizeDetection"));
const Graph_1 = require("../../../organisms/Graph/Graph");
const S = __importStar(require("./SessionDetailsModal.style"));
const SessionInfo_1 = __importDefault(require("./SessionInfo/SessionInfo"));
const SessionDetailsModal = react_1.default.memo(({ onClose, sessionType, streamId }) => {
    // Workaround for the typescript error
    const SessionModal = (0, react_1.useCallback)((props) => {
        return react_1.default.createElement(S.SessionDetailsModal, Object.assign({}, props));
    }, []);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    const closeHandler = (0, react_1.useCallback)(() => {
        setIsVisible(false);
        onClose();
        // clear streamId
        return () => {
            streamId = null;
        };
    }, [onClose]);
    const sessionInfoProps = (0, react_1.useMemo)(() => ({
        sessionType,
        streamId,
        isVisible,
        setIsVisible,
    }), [sessionType, streamId, isVisible]);
    return (react_1.default.createElement(SessionModal, { open: true, modal: true, nested: true, overlayStyle: {
            margin: 0,
            zIndex: 1,
            bottom: isMobile ? "4.7rem" : "6.4rem",
            borderBottom: `1px solid ${colors_1.gray200}`,
        }, contentStyle: { margin: 0 }, onClose: closeHandler, closeOnDocumentClick: false }, (close) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SessionInfo_1.default, Object.assign({}, sessionInfoProps)),
        isVisible && (react_1.default.createElement(Graph_1.Graph, { streamId: streamId, sessionType: sessionType, isCalendarPage: false, selectedTimestamp: null })),
        !isMobile && (react_1.default.createElement(S.CancelButtonX, { onClick: close },
            react_1.default.createElement("img", { src: circleCloseIcon_svg_1.default, alt: t("navbar.altClose") })))))));
});
exports.SessionDetailsModal = SessionDetailsModal;
